import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import WaitingIcon from 'src/Assets/Svg/common/waiting.svg?react'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
`

const Message = styled.div`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  max-width: 400px;
  text-align: center;
`

export const ReviewedEmptyState: FC = () => (
  <Container>
    <WaitingIcon />
    <Message>
      Your track has been submitted to curators. Once they share their feedback,
      you'll see it here. This process may take a few days, so please be
      patient.
    </Message>
  </Container>
)
